import { render, staticRenderFns } from "./PercentDisplay.vue?vue&type=template&id=54e345e6"
import script from "./PercentDisplay.vue?vue&type=script&lang=js"
export * from "./PercentDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports